import { FeedItemContext } from '../../../../../../lib/feed/interfaces'
import { appendInternalTrackingSearchParams } from '../../../utilities/analytics'
import { header, footer, language, media, getLogoTemplate } from '../feed_item'
import { createAttributes } from '../utils'

const getFooterData = ({ publisherLogo, publisherDarkLogo, publisherName }: FeedItemContext, layout) => {
  let footerLogo = publisherLogo;
  let footerLogoDark = publisherDarkLogo;
  let footerPublisherName = publisherName;

  if(['tile', 'edge-tile'].includes(layout)) {
    footerLogo = '';
    footerLogoDark = '';
    footerPublisherName = '';
  }

  return {
    footerLogo,
    footerLogoDark,
    footerPublisherName
  }
}

const defaultTemplate = (feedItem: FeedItemContext) => {
  const {
    link,
    title,
    publisherLogo,
    publisherDarkLogo,
    publisherName,
    isVideoLink,
    thumbnailUrl,
    isSponsored,
    contentType,
    contentTypeText,
    pub_time,
    layout,
    duration
  } = feedItem
  const { footerLogo, footerLogoDark, footerPublisherName } = getFooterData(feedItem, layout)

  return `
  <article 
   ${createAttributes(feedItem)}>
    <a class="block-item__body"
       href="${appendInternalTrackingSearchParams(link)}"
       data-mp-cct>
      ${media(thumbnailUrl, isVideoLink, duration, layout)}
      
      ${
        getLogoTemplate(layout, {
          publisherDarkLogo,
          publisherLogo,
          publisherName,
          isVideoLink,
          isSponsored,
        })
      }
  
      ${header(
        isSponsored,
        publisherDarkLogo,
        publisherLogo,
        publisherName,
        isVideoLink,
        layout
      )}
  
      <h1 class="block-item__title ${language}">
          <span class="block-item__headline">${title}</span>
          <span class="block-item__subtitle ${language}"></span>
      </h1>
      
      ${footer(
        title,
        link,
        isSponsored,
        contentTypeText,
        contentType,
        language,
        layout,
        footerLogoDark,
        footerLogo,
        footerPublisherName,
        isVideoLink,
        pub_time
      )}
     </a>
    </article>
  `
}

export default defaultTemplate
